var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container main",attrs:{"id":"app"}},[_c('main',[_c('navigation-component'),_c('transition',{attrs:{"name":"scale-fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('footer-component'),_c('cookie-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }